import {
  // GET_MESSAGE_MACRO,
  // LIST_MESSAGE_MACRO,
  // SAVE_MESSAGE_MACRO_SUCCESS,
  // SAVE_MESSAGE_MACRO_FAILURE,
  GET_MESSAGE_MACRO,
  GET_MESSAGE_MACRO_SUCCESS,
  GET_MESSAGE_MACRO_FAILURE,
  GET_MESSAGE_MACROS,
  GET_MESSAGE_MACROS_SUCCESS,
  GET_MESSAGE_MACROS_FAILURE,
  SUBMIT_MESSAGE_MACRO,
  SUBMIT_MESSAGE_MACRO_SUCCESS,
  SUBMIT_MESSAGE_MACRO_FAILURE,
  UPDATE_MESSAGE_MACRO,
  UPDATE_MESSAGE_MACRO_SUCCESS,
  UPDATE_MESSAGE_MACRO_FAILURE,
  DELETE_MESSAGE_MACRO,
  DELETE_MESSAGE_MACRO_SUCCESS,
  DELETE_MESSAGE_MACRO_FAILURE,
} from '../actions/types';

const initialState = {
  // messageMacro: null,
  // messageMacros: {
  //   count: 0,
  //   rows: [],
  // },
  loading: false,
  data: null,
  error: false,
};

const messageMacros = (state = initialState, action) => {
  switch (action.type) {
    case GET_MESSAGE_MACRO:
    case GET_MESSAGE_MACROS:
    case SUBMIT_MESSAGE_MACRO:
    case UPDATE_MESSAGE_MACRO:
    case DELETE_MESSAGE_MACRO:
      return { ...state, loading: true };
    case GET_MESSAGE_MACRO_SUCCESS:
    case GET_MESSAGE_MACROS_SUCCESS:
    case SUBMIT_MESSAGE_MACRO_SUCCESS:
    case UPDATE_MESSAGE_MACRO_SUCCESS:
    case DELETE_MESSAGE_MACRO_SUCCESS:
      return { loading: false, data: action.payload, error: false };
    case GET_MESSAGE_MACRO_FAILURE:
    case GET_MESSAGE_MACROS_FAILURE:
    case SUBMIT_MESSAGE_MACRO_FAILURE:
    case UPDATE_MESSAGE_MACRO_FAILURE:
    case DELETE_MESSAGE_MACRO_FAILURE:
      return { loading: false, data: null, error: action.payload };
    // case GET_MESSAGE_MACRO:
    //   return {
    //     ...state,
    //     // messageMacro: action.payload,
    //     data: action.payload,
    //   };
    // case LIST_MESSAGE_MACRO:
    //   return {
    //     ...state,
    //     // messageMacros: action.payload,
    //     data: action.payload,
    //   };
    // case SAVE_MESSAGE_MACRO_SUCCESS:
    //   return {
    //     ...state,
    //     data: action.payload,
    //   };
    // case SAVE_MESSAGE_MACRO_FAILURE:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };
    // case MESSAGE_MACRO_SUCCESS:
    //   return {
    //     ...state,
    //     data: action.payload,
    //   };
    // case MESSAGE_MACRO_FAILURE:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };
    default:
      return state;
  }
};

export default messageMacros;
